module.exports = __webpack_public_path__ + "media/images/icon-textbook-large-7455c2a6.png";